import React from "react"
import {
  ValueWithLabelContainer,
  ValueWithLabelTemplate,
  ValueLabelStackTemplate,
} from "../../../../components/layouts/containers/ValueWithLabelElements.container"
import EditableElement, {
  EDITABLE_ELEMENT_BTN_TYPES,
} from "../../../clientBudget/components/EditableElement"
import { numberFormatter } from "../../../../utils/numbers.utils"
import EditNumberTemplate from "../../components/EditNumberTemplate.compound"
import {
  CLIENT_SPRINT_CARD_MODES,
  MAX_BURNCHART_PREDICTION_AVERAGE_POINTS_PER_SPRINT,
  MAX_BURNCHART_PREDICTION_TO_DEVELOP_POINTS,
} from "../../../../consts/modules/clientReport.consts"
import { formatDateRange } from "../../../../utils/date.utils"

const ClientReportBurnchartSummary = ({
  setBurnchartState,
  burnchartState,
  handleMouseEnterLegend,
  handleMouseLeaveLegend,
  milestone,
  loading = false,
  mode,
}) => {
  const hasMilestoneTotalPoints = Number.isFinite(
    Number(milestone?.totalPoints)
  )
  const milestoneReleaseName = milestone?.nextImportantDateName
  const milestoneReleaseValue =
    milestone?.nextImportantDate ?
      formatDateRange(milestone.nextImportantDate, milestone.nextImportantDate)
    : "-"

  return (
    <ValueWithLabelContainer className="burnchart-value-with-label-container vertical-stack">
      {mode === CLIENT_SPRINT_CARD_MODES.EDITABLE && (
        <ValueWithLabelTemplate
          label="Velocidad promedio"
          value={
            <EditableElement
              placeholderTemplate={
                <div className="flex gap-1 align-items-end">
                  <span className="line-height-3">
                    {numberFormatter(burnchartState?.averagePointsPerSprint) ??
                      "-"}
                  </span>
                  <span className="line-height-4 text-xl h-fit">
                    pts/sprint
                  </span>
                </div>
              }
              placeholderClassName="text-3xl"
              onEditTemplate={({ onClose, onBlur }) => (
                <EditNumberTemplate
                  value={burnchartState?.averagePointsPerSprint}
                  onClose={onClose}
                  onBlur={onBlur}
                  onComplete={(value) =>
                    setBurnchartState({
                      ...burnchartState,
                      averagePointsPerSprint: value,
                    })
                  }
                  allowSameValue
                  inputProps={{
                    max: MAX_BURNCHART_PREDICTION_AVERAGE_POINTS_PER_SPRINT,
                    step: 0.1,
                    maxFractionDigits: 2,
                  }}
                />
              )}
              btnType={EDITABLE_ELEMENT_BTN_TYPES.PRIMARY}
              disableBtn={burnchartState?.averagePointsPerSprint === null}
              readOnly={mode === CLIENT_SPRINT_CARD_MODES.VIEW_ONLY}
            />
          }
          labelTooltip={mode === CLIENT_SPRINT_CARD_MODES.EDITABLE}
          labelTooltipContent="Promedio de puntos que se realizan por sprint"
          labelTooltipIcon="pi pi-info-circle"
          labelTooltipPosition="top"
          loading={loading}
        />
      )}
      <ValueLabelStackTemplate
        className="alcance-actual-item"
        label={
          <div
            className="color-list-legend-item"
            data-name={"Total"}
            onMouseEnter={handleMouseEnterLegend}
            onMouseLeave={handleMouseLeaveLegend}
          >
            <span className="burnchart-label">Alcance actual</span>
          </div>
        }
        color="#f3f6f7"
        value={
          <EditableElement
            placeholderTemplate={
              <div className="flex gap-1 align-items-end">
                <span className="line-height-3">
                  ~ {burnchartState?.totalPointsToComplete}
                </span>
                <span className="line-height-4 text-xl h-fit">pts dev</span>
              </div>
            }
            placeholderClassName="text-3xl"
            onEditTemplate={({ onClose, onBlur }) => (
              <EditNumberTemplate
                value={burnchartState?.totalPointsToComplete}
                onClose={onClose}
                onBlur={onBlur}
                onComplete={(value) =>
                  setBurnchartState({
                    ...burnchartState,
                    totalPointsToComplete: value,
                  })
                }
                allowSameValue
                inputProps={{
                  max: MAX_BURNCHART_PREDICTION_TO_DEVELOP_POINTS,
                  min: burnchartState?.totalCompletedPoints || 0,
                  step: 0.1,
                  maxFractionDigits: 2,
                }}
              />
            )}
            btnType={EDITABLE_ELEMENT_BTN_TYPES.PRIMARY}
            disableBtn={burnchartState?.totalPointsToComplete === null}
            readOnly={mode === CLIENT_SPRINT_CARD_MODES.VIEW_ONLY}
          />
        }
      />
      {hasMilestoneTotalPoints && (
        <ValueLabelStackTemplate
          color="#8a38f5"
          label={<span className="burnchart-label">Alcance fase actual</span>}
          value={
            <div className="flex gap-1 align-items-end">
              <span className="line-height-3">
                {numberFormatter(milestone?.totalPoints) || 0}
              </span>
              <span className="line-height-4 text-xl">pts dev</span>
            </div>
          }
        />
      )}

      <ValueLabelStackTemplate
        color="#059bb4"
        label={
          <div
            className="color-list-legend-item"
            data-name={"Completed"}
            onMouseEnter={handleMouseEnterLegend}
            onMouseLeave={handleMouseLeaveLegend}
          >
            <span className="burnchart-label">Avance Actual</span>
          </div>
        }
        value={
          <div className="flex gap-1 align-items-end">
            <span className="line-height-3">
              {numberFormatter(burnchartState?.totalCompletedPoints) || 0}
            </span>
            <span className="line-height-4 text-xl">pts dev</span>
          </div>
        }
      />
      {milestone?.nextImportantDate && (
        <ValueLabelStackTemplate
          color="#006aa6"
          label={
            <span className="burnchart-label">{milestoneReleaseName}</span>
          }
          value={<span className="line-height-3">{milestoneReleaseValue}</span>}
        />
      )}
    </ValueWithLabelContainer>
  )
}

export default ClientReportBurnchartSummary
